import dayjs from 'dayjs'

export function shouldDescriptionHaveParagraphNumbers(
  jurisdiction: string | undefined,
  publicationDate: string | undefined,
  kindCode: string | undefined
): boolean {
  const dayjsPublicationDate = publicationDate
    ? dayjs(publicationDate)
    : dayjs('1900-01-01')
  const isUS =
    jurisdiction === 'US' &&
    !!kindCode &&
    ((kindCode === 'A' && dayjsPublicationDate.isAfter(dayjs('2000-01-01'))) ||
      kindCode === 'A1' ||
      kindCode === 'A2' ||
      (kindCode === 'B1' &&
        dayjsPublicationDate.isAfter(dayjs('2010-01-01'))) ||
      kindCode === 'B2')

  const isEP = jurisdiction === 'EP'

  const isDE =
    jurisdiction === 'DE' &&
    !!publicationDate &&
    !!kindCode &&
    dayjs(publicationDate).isAfter(dayjs('1980-01-01'))

  return isUS || isEP || isDE
}
